export const motorfaqList = [
  {
    question: 'How is the motor insurance premium calculated?',
    answer:
      'Motor insurance premium is calculated basis various factors, such as IDV, deductibles, seating capacity, cubic capacity, previous insurance history etc. For comprehensive insurance plans, premium charges vary insurance provider per insurance provider on the basis of the coverage provided. Do compare insurance premium on websites like PrishaPolicy so that you get the best quote. Third-party premium amounts are decided by IRDA.',
  },
  {
    question: 'What should I do in case of an accident?',
    answer:
      'In case your vehicle meets with an accident, you should notify the police and take spot pictures. Click pictures of your vehicle as well as the other vehicle from all angles and focus on the damages. Exchange crucial information from the driver of the other vehicle, including policy number, motor insurance provider, name, phone number, etc. Contact your insurer and file a claim in order to get your damages covered. Keep your car keys and belongings safe.',
  },
  {
    question: 'What is "No Claim Bonus" in Motor Insurance?',
    answer: `No Claim Bonus" is the benefit accumulated to a policyholder in case he hasn't filed any claim throughout the policy period. According to the present Indian norms, it varies from 20-50 per cent for the comprehensive insurance plan. NCB isn't applicable for a third-party motor insurance plan. If a claim is filed, then the "No Claim Bonus" is lost for that policy period. NCB is provided to the policyholder and not to the insured car, two wheelers or commercial vehicle. At the time of the vehicle transfer, the insurance plan could be transferred to a new owner but NCB can't be transferred. The responsibility of paying the remaining balance falls on the shoulders of the new buyer. The original/former owner of the vehicle can use the NCB at the time of purchase of a new automobile`,
  },
  {
    question: `What happens if I don't buy motor insurance for my vehicle?`,
    answer: `All cars, bikes, scooters and trucks plying on Indian roads need to have a valid motor insurance policy. If you don't buy motor insurance for your vehicle, you will defy the Motor Vehicles Act, 1988 and will be liable to pay a fine of Rs. 2000 or get jailed for up to three months.`,
  },
  {
    question: 'Is buying motor insurance policy easy?',
    answer:
      'Yes. It is very easy to buy motor insurance for your vehicle, be it a two wheeler, a car or a commercial vehicle. You can get in touch with an insurance agent or visit the branch of the insurance provider. All insurance companies in India also allow vehicle owners to purchase insurance online within a few minutes without any hassles.',
  },
  {
    question: 'If I lose my motor insurance policy, Would I get a duplicate copy?',
    answer: `Yes. You have to approach the office of your motor insurance provider from where you have purchased your policy and submit a request in writing. A nominal fee would be charged for the issue of a duplicate policy. If you have purchased a motor insurance online, you can also download a duplicate copy of your policy from the insurer’s website`,
  },
];

export const motorProductItems = [
  {
    name: 'Private Car Insurance',
    bgColor: 'white',
  },
  {
    name: 'Two Wheeler Insurance',
    bgColor: 'white',
  },
  {
    name: 'Commercial Vehicle Insurance',
    bgColor: 'white',
  },
  {
    name: 'Third-Party Insurance',
    bgColor: 'white',
  },
  // {
  //   name: 'Fleet Insurance',
  // },
];
